import { useState } from "react";
import { Check, X } from "lucide-react";
import { Avatar, Empty, RoleSelect, fmtDate } from "./TeamBits";

function RequestRow({ u, onAct }) {
  const [role, setRole] = useState("team_member");
  return (
    <div data-testid={`pending-user-${u.user_id}`} className="flex flex-wrap items-center gap-4 rounded-2xl border border-border bg-card p-4">
      <Avatar u={u} />
      <div className="min-w-0 flex-1">
        <p className="font-semibold">{u.name || "—"}</p>
        <p className="truncate text-sm text-muted-foreground">{u.email}</p>
        <p className="mt-0.5 text-xs text-muted-foreground">Requested {fmtDate(u.created_at)}</p>
      </div>
      <RoleSelect value={role} onChange={setRole} testId={`pending-role-${u.user_id}`} />
      <button onClick={() => onAct(u, "approve", role)} data-testid={`approve-${u.user_id}`} className="inline-flex items-center gap-1 rounded-xl bg-emerald-600 px-3 py-2 text-sm font-semibold text-white transition-colors hover:bg-emerald-700">
        <Check className="h-4 w-4" /> Approve
      </button>
      <button onClick={() => onAct(u, "reject")} data-testid={`reject-${u.user_id}`} className="inline-flex items-center gap-1 rounded-xl border border-border px-3 py-2 text-sm font-semibold text-destructive transition-colors hover:bg-destructive/10">
        <X className="h-4 w-4" /> Reject
      </button>
    </div>
  );
}

export function PendingRequests({ users, onAct }) {
  if (!users.length) return <Empty>No pending access requests. New Google sign-ins will appear here.</Empty>;
  return <div className="space-y-3" data-testid="pending-list">{users.map((u) => <RequestRow key={u.user_id} u={u} onAct={onAct} />)}</div>;
}
